'use client'

import cx from 'classnames'
import { FC, ReactNode } from 'react'

import '@/components/Button/Button.scss'

type Props = {
  children?: ReactNode
  bgColor?: string
  textColor?: string
  fontSize?: string
  width?: string
  lineHeight?: string
  minWidth?: string
  minHeight?: string
  maxWidth?: string
  maxHeight?: string
  padding?: string
  type?: 'button' | 'submit' | 'reset'
  className?: string
  textWrap?: 'nowrap' | 'wrap'
  disabled?: boolean
  onClick?: () => void
}

const Button: FC<Props> = ({
  children,
  textColor,
  bgColor,
  fontSize,
  width,
  lineHeight,
  minWidth,
  minHeight,
  maxWidth,
  maxHeight,
  padding,
  onClick,
  className,
  textWrap = 'nowrap',
  type = 'button',
  disabled = false,
}) => {
  const style = {
    width: width,
    color: textColor,
    backgroundColor: bgColor,
    lineHeight: lineHeight,
    minWidth: minWidth,
    minHeight: minHeight,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    padding: padding,
    fontSize: fontSize,
    textWrap: textWrap,
  }

  return (
    <button
      className={cx('c-button u-mo-crop', className)}
      style={style}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      <span className="u-mo-crop__text u-mo-crop__text--inner">{children}</span>
      <span className="u-mo-crop__text u-mo-crop__text--outer">{children}</span>
    </button>
  )
}

export default Button
